import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "space-y-2" }
const _hoisted_2 = { class: "flex items-center justify-between" }
const _hoisted_3 = { class: "text-[11px] font-bold uppercase tracking-wider text-muted" }
const _hoisted_4 = { class: "text-active" }
const _hoisted_5 = { class: "flex items-center gap-2 overflow-x-auto pb-1.5 -mx-1 px-1" }

import { ref } from "vue";
import { useI18n } from "vue-i18n";
import { FavorableMonthFilter } from "@/types/calculators";


export default /*@__PURE__*/_defineComponent({
  __name: 'MonthTableFiltersComponent',
  props: {
    allDays: {},
    goldenDays: {},
    commerceDays: {},
    marriageDays: {},
    livingMoveDays: {},
    careerDays: {},
    travelDays: {},
    medicalDays: {}
  },
  emits: ["selectFilter"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

const { t } = useI18n();

const suitsDaysCount = ref(props.allDays);
const selectedFilter = ref<FavorableMonthFilter>("allDays");

function handleSelectFilter(filter: FavorableMonthFilter) {
  selectedFilter.value = filter;
  suitsDaysCount.value = props[filter];
  emit("selectFilter", filter);
}

const getButtonClasses = (type: FavorableMonthFilter) => {
  return selectedFilter.value === type
    ? "bg-active text-white border-active font-semibold shadow-sm"
    : "bg-secondary text-brown border-divider hover:bg-hover";
};
const getSpanClasses = (type: FavorableMonthFilter) => {
  return selectedFilter.value === type
    ? "bg-white/20 text-white"
    : "bg-white text-muted";
};

return (_ctx: any,_cache: any) => {
  const _component_i18n_t = _resolveComponent("i18n-t")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(t)("calculators.personal-date.month-table.filters.title")), 1),
      _createVNode(_component_i18n_t, {
        keypath: "calculators.personal-date.month-table.filters.suits-for-days",
        tag: "span",
        class: "text-xs text-alternative-gray"
      }, {
        suits: _withCtx(() => [
          _createElementVNode("strong", _hoisted_4, _toDisplayString(suitsDaysCount.value), 1)
        ]),
        total: _withCtx(() => [
          _createElementVNode("span", null, _toDisplayString(__props.allDays), 1)
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("button", {
        class: _normalizeClass(["px-3 py-2 rounded-xl border text-xs transition-all flex items-center gap-1.5 shrink-0", getButtonClasses('allDays')]),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (handleSelectFilter('allDays')))
      }, [
        _cache[8] || (_cache[8] = _createElementVNode("span", null, "📅", -1)),
        _createElementVNode("span", null, _toDisplayString(_unref(t)("calculators.personal-date.month-table.filters.all-days")), 1),
        _createElementVNode("span", {
          class: _normalizeClass(["px-1.5 py-0.2 rounded-full text-[10px]", getSpanClasses('allDays')])
        }, _toDisplayString(__props.allDays), 3)
      ], 2),
      _createElementVNode("button", {
        class: _normalizeClass(["px-3 py-2 rounded-xl border text-xs transition-all flex items-center gap-1.5 shrink-0", getButtonClasses('goldenDays')]),
        onClick: _cache[1] || (_cache[1] = ($event: any) => (handleSelectFilter('goldenDays')))
      }, [
        _cache[9] || (_cache[9] = _createElementVNode("span", null, "★", -1)),
        _createElementVNode("span", null, _toDisplayString(_unref(t)("calculators.personal-date.month-table.filters.golden-days")), 1),
        _createElementVNode("span", {
          class: _normalizeClass(["px-1.5 py-0.2 rounded-full text-[10px]", getSpanClasses('goldenDays')])
        }, _toDisplayString(__props.goldenDays), 3)
      ], 2),
      _createElementVNode("button", {
        class: _normalizeClass(["px-3 py-2 rounded-xl border text-xs transition-all flex items-center gap-1.5 shrink-0", getButtonClasses('commerceDays')]),
        onClick: _cache[2] || (_cache[2] = ($event: any) => (handleSelectFilter('commerceDays')))
      }, [
        _cache[10] || (_cache[10] = _createElementVNode("span", null, "💼", -1)),
        _createElementVNode("span", null, _toDisplayString(_unref(t)("calculators.personal-date.month-table.filters.commerce-days")), 1),
        _createElementVNode("span", {
          class: _normalizeClass(["px-1.5 py-0.2 rounded-full text-[10px]", getSpanClasses('commerceDays')])
        }, _toDisplayString(__props.commerceDays), 3)
      ], 2),
      _createElementVNode("button", {
        class: _normalizeClass(["px-3 py-2 rounded-xl border text-xs transition-all flex items-center gap-1.5 shrink-0", getButtonClasses('marriageDays')]),
        onClick: _cache[3] || (_cache[3] = ($event: any) => (handleSelectFilter('marriageDays')))
      }, [
        _cache[11] || (_cache[11] = _createElementVNode("span", null, "💍", -1)),
        _createElementVNode("span", null, _toDisplayString(_unref(t)("calculators.personal-date.month-table.filters.marriage-days")), 1),
        _createElementVNode("span", {
          class: _normalizeClass(["px-1.5 py-0.2 rounded-full text-[10px]", getSpanClasses('marriageDays')])
        }, _toDisplayString(__props.marriageDays), 3)
      ], 2),
      _createElementVNode("button", {
        class: _normalizeClass(["px-3 py-2 rounded-xl border text-xs transition-all flex items-center gap-1.5 shrink-0", getButtonClasses('livingMoveDays')]),
        onClick: _cache[4] || (_cache[4] = ($event: any) => (handleSelectFilter('livingMoveDays')))
      }, [
        _cache[12] || (_cache[12] = _createElementVNode("span", null, "🏠", -1)),
        _createElementVNode("span", null, _toDisplayString(_unref(t)("calculators.personal-date.month-table.filters.living-move-days")), 1),
        _createElementVNode("span", {
          class: _normalizeClass(["px-1.5 py-0.2 rounded-full text-[10px]", getSpanClasses('livingMoveDays')])
        }, _toDisplayString(__props.livingMoveDays), 3)
      ], 2),
      _createElementVNode("button", {
        class: _normalizeClass(["px-3 py-2 rounded-xl border text-xs transition-all flex items-center gap-1.5 shrink-0", getButtonClasses('careerDays')]),
        onClick: _cache[5] || (_cache[5] = ($event: any) => (handleSelectFilter('careerDays')))
      }, [
        _cache[13] || (_cache[13] = _createElementVNode("span", null, "📈", -1)),
        _createElementVNode("span", null, _toDisplayString(_unref(t)("calculators.personal-date.month-table.filters.career-days")), 1),
        _createElementVNode("span", {
          class: _normalizeClass(["px-1.5 py-0.2 rounded-full text-[10px]", getSpanClasses('careerDays')])
        }, _toDisplayString(__props.careerDays), 3)
      ], 2),
      _createElementVNode("button", {
        class: _normalizeClass(["px-3 py-2 rounded-xl border text-xs transition-all flex items-center gap-1.5 shrink-0", getButtonClasses('travelDays')]),
        onClick: _cache[6] || (_cache[6] = ($event: any) => (handleSelectFilter('travelDays')))
      }, [
        _cache[14] || (_cache[14] = _createElementVNode("span", null, "✈️", -1)),
        _createElementVNode("span", null, _toDisplayString(_unref(t)("calculators.personal-date.month-table.filters.travel-days")), 1),
        _createElementVNode("span", {
          class: _normalizeClass(["px-1.5 py-0.2 rounded-full text-[10px]", getSpanClasses('travelDays')])
        }, _toDisplayString(__props.travelDays), 3)
      ], 2),
      _createElementVNode("button", {
        class: _normalizeClass(["px-3 py-2 rounded-xl border text-xs transition-all flex items-center gap-1.5 shrink-0", getButtonClasses('medicalDays')]),
        onClick: _cache[7] || (_cache[7] = ($event: any) => (handleSelectFilter('medicalDays')))
      }, [
        _cache[15] || (_cache[15] = _createElementVNode("span", null, "🩺", -1)),
        _createElementVNode("span", null, _toDisplayString(_unref(t)("calculators.personal-date.month-table.filters.medical-days")), 1),
        _createElementVNode("span", {
          class: _normalizeClass(["px-1.5 py-0.2 rounded-full text-[10px]", getSpanClasses('medicalDays')])
        }, _toDisplayString(__props.medicalDays), 3)
      ], 2)
    ])
  ]))
}
}

})